{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "Обрано {conversationCount} розмов",
    "NONE": "Нічого",
    "CLEAR_SELECTION": "Очистити",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Ви впевнені, що хочете призначити {n} діалог агенту {agentName}? | Ви впевнені, що хочете призначити {n} діалогів агенту {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Ви впевнені, що хочете відкріпити {n} діалог? | Ви впевнені, що хочете відкріпити {n} діалогів?",
    "YES": "Так",
    "CANCEL": "Скасувати",
    "SEARCH_INPUT_PLACEHOLDER": "Пошук",
    "ASSIGN_AGENT_TOOLTIP": "Призначити агента",
    "ASSIGN_TEAM_TOOLTIP": "Призначити команду",
    "ASSIGN_SUCCESFUL": "Розмови успішно призначені.",
    "ASSIGN_FAILED": "Не вдалося призначити розмови, будь ласка, спробуйте ще раз.",
    "RESOLVE_SUCCESFUL": "Розмови успішно закриті.",
    "RESOLVE_FAILED": "Не вдалося закрити розмови, будь ласка, спробуйте ще раз.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Розмови, які відображаються на цій сторінці, обрані.",
    "UPDATE": {
      "CHANGE_STATUS": "Змінити статус",
      "SNOOZE_UNTIL": "Відкласти",
      "UPDATE_SUCCESFUL": "Статус розмови успішно оновлено.",
      "UPDATE_FAILED": "Не вдалося оновити розмови, будь ласка, спробуйте ще раз."
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Cannot resolve conversations due to missing required attributes",
      "PARTIAL_SUCCESS": "Some conversations need required attributes before resolving and were skipped"
    },
    "LABELS": {
      "ASSIGN_LABELS": "Призначити мітки",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "Призначити вибрані мітки",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "Мітки додано успішно.",
      "ASSIGN_FAILED": "Не вдалося призначити мітки, будь ласка, спробуйте ще раз.",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "Нiчого",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Ви впевнені, що хочете призначити {n} діалог команді {teamName}? | Ви впевнені, що хочете призначити {n} діалогів команді {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Ви впевнені, що хочете відкріпити {n} діалог? | Ви впевнені, що хочете відкріпити {n} діалогів?",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Не вдалося призначити команду, будь ласка, спробуйте ще раз."
    }
  }
}
